var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.573,
    height: 12.655,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8090"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8089"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2009",
    d: "M8 1.333l-.713.713-.713-.713a3.705 3.705 0 00-5.242 5.238l5.642 5.7a.44.44 0 00.624 0l5.639-5.7A3.705 3.705 0 007.999 1.33zm4.618 4.62l-5.33 5.389-5.333-5.389a2.828 2.828 0 014-4l1.022 1.022a.438.438 0 00.62 0l1.022-1.022a2.828 2.828 0 014 4z",
    fill: "#5200f1",
    stroke: "#5222f2",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartPurple);
export default __webpack_public_path__ + "static/media/heart-purple.33c7e9dcbf52defe2c6a9638430d1744.svg";
export { ForwardRef as ReactComponent };